
import { createContext, useCallback, useContext, useState } from "react";
import ReportPreview from "../../components/ReportPreview";
import IReport from "../../interfaces/IReport";


interface IReportPreviewContext {
    handleOpen: (report: IReport, filters: any) => void;
}


const ReportPreviewContext = createContext<IReportPreviewContext | undefined>(undefined);

const ReportPreviewContextProvider = (props: React.PropsWithChildren) => {
    const [open, setOpen] = useState<boolean>(false);
    const [selectedReport, setSelectedReport] = useState<IReport | undefined>(undefined);
    const [filters, setFilters] = useState<any>(undefined);

    const handleOpen = useCallback((report: IReport, filters: any) => {
        setSelectedReport(report);
        setFilters(filters);
        setOpen(true);
        
        // eslint-disable-next-line
    }, []);


    const handleClose = useCallback(() => {
        setOpen(false);
        setSelectedReport(undefined);
        // eslint-disable-next-line
    }, []);
    
    
    const data: IReportPreviewContext = {
        handleOpen
    }

    return (
        <ReportPreviewContext.Provider value={data}>
            {props.children}

            <ReportPreview
                open={open}
                handleClose={handleClose}
                report={selectedReport}
                filters={filters}
            />
        </ReportPreviewContext.Provider>
    );
}


const useReportPreviewContext = () => {
    const context = useContext(ReportPreviewContext);

    if (context === undefined) {
        throw new Error('useReportPreviewContext must be used within a ReportPreviewContextProvider');
    }

    return context;
}

export {
    useReportPreviewContext
}

export default ReportPreviewContextProvider;